import { FormOptions } from "@tt-app/models";

export const getLabelForOptionValue = <T>(
  options: FormOptions<T>[],
  value: T
): string | undefined => {
  return options
    .filter(o => o.value === value)
    .map(o => o.label)
    .find(() => true);
};
